import { z } from 'zod';

const TASK_NAME_MAX_LENGTH = 256;

export const ExamCourseSelectionSchema = z.object({
  examCourse: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    {
      message: 'กรุณาเลือกหลักสูตรทดสอบ',
    },
  ),
});

export const QSetSelectionSchema = z.object({
  qsetId: z.string().array(),
});

export const TaskDetailSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'กรุณากรอก Task Name' })
    .max(TASK_NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${TASK_NAME_MAX_LENGTH} ตัวอักษร`,
    }),
  assignTo: z.enum(['DELEGATED', 'DIRECT'], { message: 'กรุณาเลือก Assignment Type' }),
  assignee: z.object(
    {
      label: z.string(),
      value: z.string(),
      inputValue: z.string().nullish(),
    },
    { message: 'กรุณาเลือก Assignee' },
  ),
  dueDate: z.date({ message: 'กรุณาเลือก Due Date' }),
});

export const QSetReviewTaskCreationFormSchema = z.object({
  examCourseSelection: ExamCourseSelectionSchema,
  qsetSelection: QSetSelectionSchema,
  taskDetails: TaskDetailSchema,
});

export type QSetReviewTaskCreationFormInput = z.infer<typeof QSetReviewTaskCreationFormSchema>;
